import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useLazyGetRoomSessionQuery } from '../../../../../store/media/media'
import { selectRoomSessionPollingEnabled, setRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { usePollingEffect } from '../../common/hooks/usePollingEffect'

export const MeetingPreparationPoller: React.FC = () => {
  const { roomId = '', sessionId = '' } = useParams()
  const accountId = useAppSelector(selectAccountId)

  usePollRoomSession(accountId, roomId, sessionId)

  return null
}

const usePollRoomSession = (accountId: string, roomId: string, sessionId: string) => {
  const dispatch = useAppDispatch()

  const [triggerGetRoomSession] = useLazyGetRoomSessionQuery()

  const roomSessionPollingEnabled = useAppSelector(selectRoomSessionPollingEnabled)

  const getRoomSession = useCallback(async () => {
    const { data: roomSession } = await triggerGetRoomSession({
      accountId,
      roomId,
      sessionId,
    })
    if (!roomSession?.data) {
      return
    }
    dispatch(setRoomSession(roomSession.data))
  }, [accountId, dispatch, roomId, sessionId, triggerGetRoomSession])

  const { start: startRoomSessionPolling, stop: stopRoomSessionPolling } = usePollingEffect(getRoomSession, [], {
    interval: 10000,
  })

  useEffect(() => {
    if (roomSessionPollingEnabled) {
      startRoomSessionPolling()
    } else {
      stopRoomSessionPolling()
    }
  }, [roomSessionPollingEnabled, startRoomSessionPolling, stopRoomSessionPolling])
}
